define('adminAnaAssayDetailsView',[
  'module',
  'marionette',
  'underscore',
  'backbone',
  'app',
  'settings',
  'imageUtils',
  'template!adminAnaAssayDetailsTpl',
  'adminAnaAssayTabs',
  'rolesMixin',
  'backToListBehavior'
], function (
  module,
  Marionette,
  _,
  Backbone,
  App,
  Settings,
  imageUtils,
  viewTpl,
  anaAssaysTabs,
  RolesMixin,
  BackToListBehavior
) {
  'use strict';

  var AnaAssaysDetailsView =  Marionette.LayoutView.extend({
    template: viewTpl,

    ui: {
      tab: '.anaassay-tab',
      tabPane: '.tab-pane',
      logo: '.js-logo-holder',
      name: '.p-name',
      code: '.p-code'
    },

    regions: {
      anaAssayDetailTab: '#detail-tab'
    },

    behaviors: function() {
      var redirectUrl = 'admin/assays/'+this.options.model.get('refAssay').secId+'/anaassay';
      return {
        BackToList: {
          behaviorClass: BackToListBehavior,
          redirectUrl: redirectUrl
        }
      };
    },

    serializeData: function() {
      var templateData = this.model.toJSON();
      templateData.anaAssaysTabs = anaAssaysTabs;
      return templateData;
    },

    onRender: function() {
      if (this.options.data.tab) {
        this.ui.tab.removeClass('active');
        this.$el.find('.tab-pane').removeClass('active');
        this.$el
          .find('.anaassay-tab[data-name="' + this.options.data.tab.name + '"]')
          .addClass('active');
        this.$el
          .find('.tab-pane[data-name="' + this.options.data.tab.name + '"]')
          .addClass('active');
      }
    },

    onShow: function() {
      $.material.init();
    }
  });

  module.exports = AnaAssaysDetailsView;
});
